import { AfterViewInit, ChangeDetectionStrategy, Component, Input, OnInit, inject } from '@angular/core'
import { DomSanitizer, SafeHtml } from '@angular/platform-browser'
import iframeResize from '@iframe-resizer/parent'


@Component({
    selector: 'linked-in',
    templateUrl: './linked-in.component.html',
    styleUrls: ['./linked-in.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true
})
export class LinkedInComponent implements AfterViewInit {
  private sanitiser = inject(DomSanitizer)


  public _iframeHTML: SafeHtml = ''

  @Input() set handle(handle: string) {
    if (handle !== '') {
      this._iframeHTML = this.sanitiser.bypassSecurityTrustHtml(`
        <html>
          <head>
          <link rel="stylesheet" href="https://static.licdn.com/sc/h/2lgytu9f1z9n54epparouqzhy">
          <script src="https://platform.linkedin.com/badges/js/profile.js" async defer type="text/javascript"></script>
          <script src="https://cdn.jsdelivr.net/npm/@iframe-resizer/child"></script>
          </head>
          <body>
          <div
            class="badge-base LI-profile-badge"
            data-locale="en_US"
            data-size="large"
            data-theme="${this.getColourMode()}"
            data-type="HORIZONTAL"
            data-vanity="${handle}" data-version="v1">
          </div>
          </body>
        </html>
      `)
    } else {
      this._iframeHTML = ''
    }
  }


  public elementID = 'linkedin' + Math.floor(Math.random() * 99999)

  ngAfterViewInit() {
    iframeResize({
      //log: true,
      license: '1mjb12zhxy1-1ov9n7qh0ct-263od7bccj7',
      checkOrigin: false
    }, '#' + this.elementID)
  }

  getColourMode() {
    if (window.matchMedia('(prefers-color-scheme: dark)').matches) {
      return 'dark'
    } else {
    return 'light'
    }
  }
}
